import * as React from 'react';
import { Button, ButtonGroup, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { IFile } from '../Entities';
import { Translate } from '../../../shared/LanguageService';
import Dropzone from '../../../components/common/Dropzone';
import PlaceholderImage from '../../../assets/images/placeholder-image.png';

interface IProps {
    file: IFile;
    dropzoneId: string;
    actionUrl: string;
    upload: boolean;
    shouldUseEditTexts: boolean;
    onUploadCompleted: () => void;
    onFileUploadCompleted: (response: any) => void;
    onUpload: () => void;
    onEditTexts: () => void;
    onClick: () => void;
    onCompare: () => void;
    title: string;
    isAnnotation: boolean;
    readonly?: boolean;
}

const FileTypeForm = (props: IProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <Col xs={12} sm={6}>
            <fieldset className="planeditor-fieldset">
                <legend>{props.title}</legend>
                {props.isAnnotation && (
                    <i
                        className="material-icons image-action-warning"
                        title={Translate('order/plan/returned/annotation-title')}
                    >
                        feedback
                    </i>
                )}
                <Row>
                    <Col sm={3}>
                        {props.file && (
                            <div className="button-bar-below">
                                <div className="content-row">
                                    <img
                                        onClick={props.onClick}
                                        src={`${apiUrl}/file/${props.file.thumbnailReference}`}
                                    />
                                </div>
                                <div className="button-row">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-compare">
                                                <p>
                                                    {Translate('order/plan/storey/compare-button')}
                                                </p>
                                            </Tooltip>
                                        }
                                    >
                                        <Button bsStyle="default" onClick={props.onCompare}>
                                            <i className="material-icons no-label">photo_library</i>
                                        </Button>
                                    </OverlayTrigger>
                                    {props.shouldUseEditTexts && (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-edit-texts">
                                                    <p>
                                                        {Translate(
                                                            'planeditor/orders/edit/edit-texts'
                                                        )}
                                                    </p>
                                                </Tooltip>
                                            }
                                        >
                                            <Button bsStyle="default" onClick={props.onEditTexts}>
                                                <i className="material-icons no-label">
                                                    text_fields
                                                </i>
                                            </Button>
                                        </OverlayTrigger>
                                    )}
                                </div>
                            </div>
                        )}

                        {!props.file && (
                            <div>
                                <img src={PlaceholderImage} className="placeholder-image" alt="" />
                            </div>
                        )}
                    </Col>
                    <Col sm={3}>
                        {!props.readonly && (
                            <div className="button-bar-below">
                                <div className="content-row">
                                    <Dropzone
                                        dropzoneHtmlId={props.dropzoneId}
                                        actionUrl={props.actionUrl}
                                        upload={props.upload}
                                        onUploadCompleted={props.onUploadCompleted}
                                        onFileUploadCompleted={props.onFileUploadCompleted}
                                        uploadMultiple={false}
                                        maxFiles={1}
                                        removeFileAfterSuccess={true}
                                        acceptedFiles={'image/jpeg,image/png,image/gif,application/pdf'}
                                    />
                                </div>
                                <div className="button-row">
                                    <ButtonGroup bsSize="sm">
                                        <Button bsStyle="info" onClick={props.onUpload}>
                                            <i className="material-icons">cloud_upload</i>{' '}
                                            {Translate(
                                                'planeditor/orders/edit/files/upload-button'
                                            )}
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
            </fieldset>
        </Col>
    );
};

export default FileTypeForm;
